module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/wait-for-user-input-icon-e8cdee0626935f1531d5a3e1868cbe0d.png";